export enum SentimentType {
  EXCELLENT = 'Excellent',
  GOOD = 'Good',
  NEEDS_IMPROVEMENT = 'Needs Improvement',
}
